<mat-card class="p-4">
  <mat-card-title><div class="mb-2 text-xl font-bold">{{title()}}</div></mat-card-title>

  <mat-card-content>
    <div class="mce-upload-row">
      @if (imageSrc) {
        <div class="min-w-0">
          <img [src]="imageSrc" alt="Selected image" class="max-h-64 max-w-full rounded-xl shadow-sm" />
        </div>
      }

      <div class="mce-upload-input text-primary">
        <input type="file" (change)="onFileSelected($event)" accept="image/jpeg, image/png" class="cursor-pointer">
        @if (errorMessage) {
          <mat-error>{{ errorMessage }}</mat-error>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>



